import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Table from '../../atoms/table/Table';
import NoDataTableRow from '../../molecules/table/NoDataTableRow';
import ReportExportTableRow from '../../molecules/table/ReportExportTableRow';
import ReportExportTableHeader from '../../molecules/table/ReportExportTableHeader';
const ReportExportTable = ({ reportExports }) => {
    const getDataRows = () => {
        if (reportExports.length === 0) {
            return _jsx(NoDataTableRow, {});
        }
        return (reportExports.length > 0 &&
            reportExports.map(reportExport => (_jsx(ReportExportTableRow, { reportExport: reportExport }, reportExport.id))));
    };
    return (_jsxs(Table, { children: [_jsx(ReportExportTableHeader, {}), getDataRows()] }));
};
export default ReportExportTable;
